import jwtDecode from "jwt-decode";

/**
 * Mirror of `packages/ui/src/core/auth/idp-token.ts`. ui-legacy is a
 * separate package so it cannot import the helper directly; keep this file
 * in sync with the canonical implementation if either side changes.
 */
export const IDP_TOKEN_KEY = "https://superblocks/api/idp_token";

export type IdpTokenInspection =
  | { present: false }
  | { present: true; format: "opaque" }
  | { present: true; format: "jwt"; expired: boolean };

export function inspectIdpTokenInAuth0Jwt(
  auth0Jwt: string | null | undefined,
): IdpTokenInspection {
  if (!auth0Jwt) {
    return { present: false };
  }

  let decodedAuth0Jwt: Record<string, unknown>;
  try {
    decodedAuth0Jwt = jwtDecode(auth0Jwt);
  } catch {
    return { present: false };
  }

  const idpToken = decodedAuth0Jwt[IDP_TOKEN_KEY];
  if (typeof idpToken !== "string" || idpToken.length === 0) {
    return { present: false };
  }

  let decodedIdpToken: Record<string, unknown>;
  try {
    decodedIdpToken = jwtDecode(idpToken);
  } catch {
    return { present: true, format: "opaque" };
  }

  const exp = decodedIdpToken.exp;
  const expired = typeof exp === "number" ? exp < Date.now() / 1000 : false;
  return { present: true, format: "jwt", expired };
}
